<template>
  <div
    v-if="missionsList"
    id="mission-list-wrapper"
    class="d-flex flex-column p-5 missions-wrapper"
    @scroll="fetchMore"
  >
    <div
      v-if="showCloseBtn"
      class="stick-top-right"
      style="top: 10px; right: 16px;"
    >
      <button
        type="button"
        class="btn-close md-close vs-btn-legacy"
        @click="closeModal"
      />
    </div>
    <h2 class="my-2">
      Missions
    </h2>
    <span class="mb-4">Complete Missions & Claim Your Points Now to Level Up!</span>
    <div
      v-for="(mission, index) in missionsList"
      :key="index"
      class="d-flex justify-content-between align-items-center mb-4"
    >
      <div
        class="circular-progress-bar"
        :style="{background: `radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#E81A65 ${missionProgress(mission)}, #d3d3d3 0%)` }"
      >
        <div class="d-flex flex-column justify-items-center">
          <span class="mission-reward-amount">{{ mission.rewards[0].amount }}</span>
          <span class="mission-reward-type">{{ mission.rewards[0].currencyType }}</span>
        </div>
        <progress
          value="75"
          min="0"
          max="100"
          style="visibility:hidden;height:0;width:0;"
        />
      </div>

      <div
        id="mission-content"
        class="d-flex mx-5 flex-grow-1"
      >
        <div class="d-flex flex-column">
          <span class="mission-description mr-4 font-weight-bold">{{ mission.description }}</span>
          <span class="mission-progress">{{ mission.isAchieved ? 'Completed' : `${mission.currentTaskCount}/${mission.requiredTaskCount} Completed` }}</span>
        </div>
      </div>
      <button
        type="button"
        :disabled="mission.isClaimed || !mission.isAchieved"
        class="action-btn vs-btn"
        :style="mission.isClaimed && {backgroundColor: '#a9a9a9'}"
        @click="claimMission(mission.id)"
      >
        {{ mission.isAchieved ? mission.isClaimed ? "Claimed" : "Claim" : "In Progress" }}
      </button>
    </div>
  </div>
  <div
    v-else
    class="p-6 text-center"
  >
    Loading...
  </div>
</template>

<script lang="ts">

import Vue from 'vue';
import { Mission } from '@viddsee/server-api-client/types/models/me/point-system';
import { meApi } from '@/scripts/webcall/v3/me';
import { initMissions } from '@/scripts/pages/shared/legacy-pages/vs-navbar';

export default Vue.extend({
  props: {
    closeModal: {
      type: Function,
      default: null,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 0,
      maxPage: 99,
      missionsList: null as null | Array<Mission>,
    };
  },
  async created() {
    this.getMissionsList(this.currentPage);
  },
  methods: {
    missionProgress(mission: Mission): any {
      return `${(mission.currentTaskCount/mission.requiredTaskCount)*100}%`;
    },

    async getMissionsList(page: number): Promise<void> {
      await meApi.pointSystemApi.listMissions(undefined, { page }).then((data) => {
        if (page === 0) {
          this.missionsList = data.data.items;
          this.maxPage = data.data.pageCount;
        } else {
          this.missionsList?.push(...data.data.items);
        }
      });
    },

    async claimMission(id: number): Promise<void> {
      await meApi.pointSystemApi.ClaimMission({ attemptId: id }, undefined, undefined)
        .then((data) => {
          if (data.data.claimed === true) {
            initMissions(true).then(() => {
              this.getMissionsList(0);
            });
          }
        });
    },

    async fetchMore({ target: { scrollTop, clientHeight, scrollHeight } }: any): Promise<void> {
      if (scrollTop + clientHeight >= scrollHeight && this.currentPage < this.maxPage -1) {
        this.getMissionsList(this.currentPage + 1);
        this.currentPage = this.currentPage + 1;
      }
    },
  },

});
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.missions-wrapper {
  max-height: 800px;
  overflow-y: scroll;
}
.action-btn {
  font-family: $font-family-base;
  font-weight: initial;
  border-radius: 4px;
  background-color: $primary;
  color: white;
  vertical-align: middle;
  text-align: center !important;
  min-width: 20% !important;
  min-height: 40px;
  padding:4px 8px;
  &:disabled {
    opacity: $btn-disabled-opacity;
    cursor: default;
    @include box-shadow(none);
  }
}

.circular-progress-bar {
  display: flex;
  min-width: 100px;
  height: 100px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
}

.mission-reward-amount {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
}
.mission-reward-type {
  font-weight: 600;
  text-align: center;
}
</style>
